export default {
    data() {
        return {
            downloading: false
        };
    },
    methods: {
        downloadFile({ url, fallbackFilename = '' }) {
            const self = this;
            self.downloading = true;

            self.$http
                .get(url, { responseType: 'blob' })
                .then((response) => {
                    const headers = response.headers;
                    const blob = new Blob([response.data], {
                        type: headers['content-type']
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);

                    let filename = '';
                    if (headers['content-disposition']) {
                        filename = headers['content-disposition'].split('"')[1];
                        filename = filename.split('"')[0];
                    } else {
                        filename = fallbackFilename;
                    }
                    link.download = filename;
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    self.downloading = false;
                });
        }
    }
};
